/* ============================================================
   PH PERFUMERÍA
   PH Home Search v3.0

   Responsabilidades:
   - Controlar el buscador principal del Home.
   - Mostrar resultados mientras se escribe.
   - Activar filtros por categoría.
   - Mantener un solo chip activo.
   - Controlar botón limpiar.
   - Controlar indicador de scroll horizontal.
   - Mostrar 3 resultados en móvil y 5 en escritorio.
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {
  'use strict';

  const root = document.querySelector(
    '[data-ph-home-search]'
  );

  if (!root) return;


  /* =========================================================
     ELEMENTOS
     ========================================================= */

  const input = root.querySelector(
    '[data-ph-search-input]'
  );

  const form = root.querySelector(
    '[data-ph-search-form]'
  );

  const clearButton = root.querySelector(
    '[data-ph-search-clear]'
  );

  const resultsContainer = root.querySelector(
    '[data-ph-search-results]'
  );

  const status = root.querySelector(
    '[data-ph-search-status]'
  );

  const categoryButtons = Array.from(
    root.querySelectorAll(
      '[data-ph-category]'
    )
  );

  const categoryScroller = root.querySelector(
    '[data-ph-category-scroll]'
  );

  const categoryHint = root.querySelector(
    '[data-ph-category-hint]'
  );

  if (!input || !form) return;


  /* =========================================================
     PLACEHOLDERS
     ========================================================= */

  const placeholders = [
    'Busca entre +600 aromas...',
    'Ej. Sauvage...',
    'Ej. Libre...',
    'Ej. Baccarat Rouge 540...',
    'Ej. Good Girl...',
    'Ej. Layton...',
    'Ej. Acqua di Gio Profondo...',
    'Ej. Black Opium...'
  ];

  let placeholderIndex = 0;


  /* =========================================================
     MAPA DE CATEGORÍAS
     ========================================================= */

  const CATEGORY_MAP = {
    caballero: {
      filter: 'caballero',
      category: 'caballero',
      label: 'Caballero'
    },

    dama: {
      filter: 'dama',
      category: 'dama',
      label: 'Dama'
    },

    nicho: {
      filter: 'nicho',
      category: 'nicho',
      label: 'Nicho'
    },

    arabe: {
      filter: 'arabes',
      category: 'arabes',
      label: 'Árabes'
    },

    arabes: {
      filter: 'arabes',
      category: 'arabes',
      label: 'Árabes'
    },

    unisex: {
      filter: 'unisex',
      category: 'unisex',
      label: 'Unisex'
    }
  };


  /* =========================================================
     UTILIDADES
     ========================================================= */

  function getResultsLimit() {
    return window.matchMedia(
      '(max-width: 900px)'
    ).matches
      ? 3
      : 5;
  }


  function connectPHElements() {
    if (!window.PH) return;

    PH.elements.searchInput = input;
    PH.elements.searchResults = resultsContainer;
    PH.elements.searchClear = clearButton;
  }


  function updateClearButton() {
    if (!clearButton) return;

    clearButton.hidden =
      input.value.trim().length === 0;
  }


  function clearActiveCategories() {
    categoryButtons.forEach(button => {
      button.classList.remove(
        'is-active',
        'ph-chip-active'
      );

      button.setAttribute(
        'aria-pressed',
        'false'
      );
    });
  }


  function clearResults() {
    if (resultsContainer) {
      resultsContainer.innerHTML = '';
    }

    if (status) {
      status.textContent = '';
    }
  }


  function resetState() {
    if (!window.PH) return;

    PH.state.search = '';
    PH.state.activeFilter = null;
    PH.state.category = '';
  }


  /* =========================================================
     BUSCADOR
     ========================================================= */

  function runSearch() {
    if (
      !window.PH ||
      typeof PH.render !== 'function'
    ) {
      return;
    }

    connectPHElements();
    updateClearButton();
    clearActiveCategories();

    PH.state.search =
      input.value.trim();

    PH.state.activeFilter = null;
    PH.state.category = '';

    PH.render();
  }


  input.addEventListener(
    'input',
    () => {
      runSearch();
    }
  );


  form.addEventListener(
    'submit',
    event => {
      event.preventDefault();

      runSearch();

      if (
        input.value.trim().length < 2
      ) {
        input.focus();
      }
    }
  );


  /* =========================================================
     LIMPIAR BÚSQUEDA
     ========================================================= */

  if (clearButton) {
    clearButton.addEventListener(
      'click',
      () => {
        input.value = '';

        clearButton.hidden = true;

        clearActiveCategories();
        clearResults();
        resetState();

        input.placeholder =
          placeholders[0];

        input.focus();
      }
    );
  }


  /* =========================================================
     RESULTADOS DE CATEGORÍA
     ========================================================= */

  function setCategoryStatus(
    label,
    amount
  ) {
    if (!status) return;

    status.textContent =
      amount > 0
        ? `${amount} perfumes de ${label}`
        : `No encontramos perfumes de ${label}`;
  }


  function renderCategoryResults(
    categoryData
  ) {
    if (
      !window.PH ||
      typeof PH.getSearchResults !==
        'function'
    ) {
      return;
    }

    connectPHElements();

    PH.state.search = '';

    PH.state.activeFilter =
      categoryData.filter;

    PH.state.category =
      categoryData.category;

    input.value = '';

    updateClearButton();

    input.placeholder =
      `Buscar perfumes de ${categoryData.label}...`;

    let results = [];

    try {
      results =
        PH.getSearchResults() || [];
    } catch (error) {
      window.PH?.error?.(
        '[PH Home Search] No se pudieron cargar los resultados de categoría.',
        error
      );

      results = [];
    }

    const visibleResults =
      results.slice(
        0,
        getResultsLimit()
      );

    if (
      PH.ui &&
      typeof PH.ui.renderSearchResults ===
        'function' &&
      resultsContainer
    ) {
      PH.ui.renderSearchResults(
        resultsContainer,
        visibleResults
      );
    }

    setCategoryStatus(
      categoryData.label,
      visibleResults.length
    );

    document.dispatchEvent(
      new CustomEvent(
        'ph:home-category:select',
        {
          detail: {
            category:
              categoryData.category,

            results:
              visibleResults.length
          }
        }
      )
    );
  }


  /* =========================================================
     ACTIVAR / DESACTIVAR CATEGORÍA
     ========================================================= */

  function toggleCategory(button) {
    if (!window.PH) return;

    const rawCategory =
      button.dataset.phCategory;

    const categoryData =
      CATEGORY_MAP[rawCategory];

    if (!categoryData) return;

    const isAlreadyActive =
      button.classList.contains(
        'is-active'
      );

    clearActiveCategories();

    if (isAlreadyActive) {
      resetState();
      clearResults();

      input.placeholder =
        placeholders[0];

      return;
    }

    button.classList.add(
      'is-active',
      'ph-chip-active'
    );

    button.setAttribute(
      'aria-pressed',
      'true'
    );

    renderCategoryResults(
      categoryData
    );
  }


  categoryButtons.forEach(button => {
    button.setAttribute(
      'aria-pressed',
      'false'
    );

    button.addEventListener(
      'click',
      event => {
        event.preventDefault();

        toggleCategory(button);
      }
    );
  });


  /* =========================================================
     PLACEHOLDER ROTATIVO
     ========================================================= */

  input.placeholder =
    placeholders[0];

  window.setInterval(() => {
    if (
      document.activeElement === input ||
      input.value.trim() ||
      (
        window.PH &&
        PH.state &&
        PH.state.activeFilter
      )
    ) {
      return;
    }

    placeholderIndex =
      (placeholderIndex + 1) %
      placeholders.length;

    input.placeholder =
      placeholders[
        placeholderIndex
      ];
  }, 2600);


  /* =========================================================
     FLECHA DE SCROLL DE CHIPS
     ========================================================= */

  function updateCategoryHint() {
    if (
      !categoryScroller ||
      !categoryHint
    ) {
      return;
    }

    const hasOverflow =
      categoryScroller.scrollWidth >
      categoryScroller.clientWidth + 4;

    const reachedEnd =
      categoryScroller.scrollLeft +
      categoryScroller.clientWidth >=
      categoryScroller.scrollWidth - 8;

    categoryHint.classList.toggle(
      'is-hidden',
      !hasOverflow || reachedEnd
    );
  }


  if (
    categoryScroller &&
    categoryHint
  ) {
    updateCategoryHint();

    categoryScroller.addEventListener(
      'scroll',
      updateCategoryHint,
      {
        passive: true
      }
    );

    window.addEventListener(
      'resize',
      updateCategoryHint,
      {
        passive: true
      }
    );

    /*
     * Revisa otra vez después de que
     * fuentes / layout terminen de cargar.
     */
    window.setTimeout(
      updateCategoryHint,
      300
    );
  }


  /* =========================================================
     ESTADO INICIAL
     ========================================================= */

  updateClearButton();
  connectPHElements();
});
